module.exports = __webpack_public_path__ + "img/myqr.92f9b612.png";